import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';

export function registerExpandableChangePasswordFormResourceBundleEn(
  i18next: i18n
): void {
  i18next.addResourceBundle(
    'en',
    'record-it-components',
    {
      form: {
        ExpandableChangePasswordForm: {
          cancel: 'cancel',
          changePassword: 'change password',
          changeToNewPassword: 'use new password',
          changeToNewPasswordError: 'Changing the password was not successful.',
          changeToNewPasswordSuccess: 'Successfully changed the password.',
          currentPassword: 'current password',
          currentPasswordIsRequired: '"current password" is required',
          label: 'change password',
          newPassword: 'new password'
        }
      }
    } as Partial<CustomTypeOptions['resources']['record-it-components']>,
    true
  );
}
